module.exports = __webpack_public_path__ + "img/AdobeStock_268899014.jpeg";